import React from 'react';
import { Icon } from 'ui';
import Table from '../../table';
import IndexTableHeaderCell from './header_cell';
import SelectAllCell from '../select_all_cell';

function tableHeaderClasses(classes, useHideClass) {
  if (useHideClass && classes !== undefined) {
    return classes.hideBelowXS || classes.hideBelowMD;
  }

  return classes;
}

const IndexTableHeader = ({ selectable, tableHeaders, useHideClass }) => {
  const indexHeaderCells = tableHeaders.map(
    ({ size, name, label, classes, getTooltip, clickable, sortType }) => (
      <IndexTableHeaderCell
        size={size}
        {...tableHeaderClasses(classes, useHideClass)}
        name={name}
        key={label}
        clickable={clickable}
        sortType={sortType}
      >
        {label}
        {getTooltip && (
          <span
            className="h-ci ml-4"
            data-toggle="tooltip"
            title={getTooltip()}
            data-placement="top"
          >
            <Icon
              aria-label="Filter Icon"
              name="info"
              className="NestedList-headerIcon c-brand-gray"
            />
          </span>
        )}
      </IndexTableHeaderCell>
    ),
  );

  return (
    <Table.Header>
      {selectable && <SelectAllCell />}
      {indexHeaderCells}
    </Table.Header>
  );
};

export default IndexTableHeader;
